import { Component, type ReactNode } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { EmptyState } from "@/components/ui/misc";

/**
 * Váratlan hiba esetén barátságos oldal fehér képernyő helyett. A leggyakoribb eset, hogy közben
 * új verzió került ki, ezért az újratöltés megoldja.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error("[propsys] oldalhiba:", error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const chunk = /dynamically imported module|Importing a module script failed|Failed to fetch/i.test(this.state.error.message);
    return (
      <div className="flex min-h-dvh items-center justify-center p-6">
        <Card className="w-full max-w-lg">
          <EmptyState
            icon={<RefreshCw />}
            title={chunk ? "Közben frissült a rendszer 🔄" : "Hoppá, ez az oldal elakadt"}
            description={
              chunk
                ? "Új verzió került ki, ezért ez az oldal nem töltött be. Egy frissítés megoldja – az adataid nem vesztek el."
                : "Váratlan hiba történt a megjelenítés közben. Töltsd újra az oldalt; ha újra előjön, szólj nekünk."
            }
            action={
              <Button onClick={() => window.location.reload()}>
                <RefreshCw /> Újratöltés
              </Button>
            }
          />
        </Card>
      </div>
    );
  }
}
